// src/components/compartment_report/compartment_report.js
//
// Top-level Compartment Report page: switches between ReportingHistoryPage
// (the default, list of all reportings), PreflightWizardPage (the 4-tab
// Select Data -> Validation -> Calculation -> Reporting wizard for one
// reporting), and SettingsPage (global, fund-wide config, reached via a
// button on the history page rather than a separate top-level sidebar entry
// - mirrors reporting-hub's own Landing -> main-app structure where Settings
// is one of the views inside the app, not a separate nav item). See the plan
// file (~/.claude/plans/giggly-exploring-donut.md) for the full feature
// inventory and phased build order this is following.
//
// `openReportingId === undefined` means "history view"; `null` means "new
// reporting, not created yet" (wizard view, Select Data tab only); a real id
// means an existing reporting opened from history.

import React, { useState } from 'react';
import ReportingHistoryPage from './pages/ReportingHistoryPage';
import PreflightWizardPage from './pages/PreflightWizardPage';
import SettingsPage from './settings/SettingsPage';
import './compartment_report.css';

const CompartmentReport = ({ setLoading = () => {} }) => {
  const [openReportingId, setOpenReportingId] = useState(undefined);
  const [showSettings, setShowSettings] = useState(false);

  if (showSettings) {
    return <SettingsPage onBack={() => setShowSettings(false)} setLoading={setLoading} />;
  }

  if (openReportingId === undefined) {
    return (
      <ReportingHistoryPage
        onOpen={setOpenReportingId}
        onOpenSettings={() => setShowSettings(true)}
        setLoading={setLoading}
      />
    );
  }

  return (
    <PreflightWizardPage
      reportingId={openReportingId}
      onBack={() => setOpenReportingId(undefined)}
      setLoading={setLoading}
    />
  );
};

export default CompartmentReport;
